/** Mirrors `apps/backend/src/modules/accounts/account-retention-bounds.ts`; the server stays the authority. */
const retentionBounds = Object.freeze({
	audioDays: Object.freeze({ minimum: 30, maximum: 3650 }),
	beneficiaryMonths: Object.freeze({ minimum: 12, maximum: 600 }),
});

export default retentionBounds;
